/* global $, AOS */

// VENDOR FILES
// -----------------------------------------------------------------------------
import '../../source/vendor/hoverIntent.js';

// CUSTOM CODE
// -----------------------------------------------------------------------------

// Constants
const BREAKPOINT_DESKTOP = 992;
const KEY_TAB = 9;
const KEY_ENTER = 13;
const KEY_ESCAPE = 'Escape';

$(document).ready(function () {
    if ($(window).width() >= BREAKPOINT_DESKTOP) {
        function closeAllMenu() {
            $('.menu-item-has-children').removeClass('sub-menu-child-open');
            $('.menu-item-has-children').find('.sub-menu').removeClass('sub-menu-open');
        }

        function toggleMenu(thisObj) {
            $('.menu-item-has-children').not(thisObj).removeClass('sub-menu-child-open');
            $('.menu-item-has-children')
                .not(thisObj)
                .find('.sub-menu')
                .removeClass('sub-menu-open');
        }

        function openMenu(thisObj) {
            thisObj.find('.sub-menu').toggleClass('sub-menu-open');
            thisObj.toggleClass('sub-menu-child-open');
            var navLinkPos = thisObj.offset().left;
            thisObj.find('.sub-menu .menu-item').css({
                left: navLinkPos,
            });
        }

        $('.menu-item-has-children > a').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var parent = $(this).parent();
            toggleMenu(parent);
            openMenu(parent);
        });

        $('.menu-item-has-children').on('keyup', function (e) {
            if (e.which === KEY_TAB) {
                e.preventDefault();
                closeAllMenu();
                openMenu($(this));
            }
            // HCAI-88 close the Reporting Hub Menu on ESC
            if (e.key === KEY_ESCAPE) {
                closeAllMenu();
            }
        });

        $('.wp-block-search__input').on('focus', function () {
            closeAllMenu();
        });

        $('html').click(function () {
            closeAllMenu();
        });

        // HCAI-88 close the Reporting Hub Menu on mouseleave
        $('.menu-download-reports-container .sub-menu').on('mouseleave', function () {
            closeAllMenu();
        });
    } else {
        $('.menu-item-has-children > a').click(function (e) {
            e.preventDefault();
            $(this).parent().find('.sub-menu').toggleClass('sub-menu-open');
            $(this).parent().toggleClass('sub-menu-child-open');
            $(this).parent().siblings().not(this).removeClass('sub-menu-child-open');
            $(this).parent().siblings().find('.sub-menu').not(this).removeClass('sub-menu-open');
        });
    }

    $('.subnav-title').click(function () {
        $(this).toggleClass('subnav-title-active');
        $('.subnav-ul').toggleClass('subnav-ul-open');
    });

    $('.nav-header-trigger').click(function () {
        $('body').toggleClass('mobile-menu-open');
        const isOpen = $('body').hasClass('mobile-menu-open');
        $(this).attr('aria-expanded', isOpen);
        $(this).attr('aria-label', isOpen ? 'Close menu' : 'Open menu');
        return false;
    });

    if ($('.pattern-group-subnav')[0]) {
        const $subnav = $('.pattern-group-subnav');
        const $window = $(window);

        add_active_class_to_subnav();
        const activeLeft = $subnav.find('.subnav-ul li.active').offset().left;
        $('.subnav-ul').scrollLeft(activeLeft - 16);

        const subNavTop = $subnav.offset().top;

        $window.scroll(function () {
            if ($window.scrollTop() >= 1) {
                $('.header-nav').addClass('header-nav-sticky');
            } else {
                $('.header-nav').removeClass('header-nav-sticky');
            }
            if ($window.scrollTop() >= subNavTop) {
                $('.pattern-group-subnav').addClass('pattern-group-subnav-sticky');
            } else {
                $('.pattern-group-subnav').removeClass('pattern-group-subnav-sticky');
            }
        });
    }

    $(
        '.page article p, .page article h1, .page article h2, .page article h3, .page article h4, .page article a, .page article li'
    ).attr('data-aos', 'fade');
    $('.wp-block-image.size-full, .wp-block-video, .wp-block-embed, .stat-header, .stat-body').attr(
        'data-aos',
        'fade-up'
    );
    $('.wp-block-image a, .subnav-ul li, .subnav-ul li a, .entry-content a').removeAttr('data-aos');
    AOS.init({
        duration: 600,
    });

    // Fix Owl Carousel ARIA roles for accessibility.
    pacecore_fix_owl_aria();
    // Re-apply after carousel events (slides may be cloned/rebuilt).
    $(document).on(
        'translated.owl.carousel refreshed.owl.carousel initialized.owl.carousel',
        function () {
            pacecore_fix_owl_aria();
        }
    );

    // Check paragraph heights against h3 above them and add class if shorter.
    pacecore_check_paragraph_heights();
    $(window).on('resize', pacecore_check_paragraph_heights);

    // Set padding-top of .columns-image-stats-stack-inner to the height of the closest h3 above it.
    pacecore_set_stack_inner_padding();
    $(window).on('resize', pacecore_set_stack_inner_padding);

    // scroll to correct #hash on page when URL contains a hash
    if (window.location.hash) {
        const scrollTarget = window.location.hash;
        const headerNavHeight = $('.header-nav').outerHeight();
        const subNavHeight = $('.pattern-group-subnav').outerHeight();
        const scrollOffset = parseInt(headerNavHeight) + parseInt(subNavHeight) - 24;

        $('html, body')
            .stop()
            .animate({
                scrollTop: $(scrollTarget).offset().top - scrollOffset,
            });
    }
});

//Adds tabindex="0" and role="button" attributes on the play/pause button for home hero video, if it exists on the page upon pageload.
if ($('.js-home-hero-bg-video-control').length) {
    $('.js-home-hero-bg-video-control').attr('tabindex', '0');
    $('.js-home-hero-bg-video-control').attr('role', 'button');

    //detect enter as a click on home hero video play/pause button when that is focused on
    $(document).on('keyup', '.js-home-hero-bg-video-control', function (e) {
        if (e.which === KEY_ENTER)
            //on enter
            $(this).click();
    });
}
//Play pause functionality for the home hero video
$(document).on('click', '.js-home-hero-bg-video-control', function () {
    const hero_video = $('.pattern-group-hero-video video');
    if (hero_video.get(0).paused) {
        $($(this)).addClass('playing');
        $($(this)).removeClass('paused');
        $($(this)).html('Pause Video');
        hero_video.trigger('play');
    } else {
        $($(this)).removeClass('playing');
        $($(this)).addClass('paused');
        $($(this)).html('Play Video');
        hero_video.trigger('pause');
    }
});

/* Add active class to sub nav if the current url matches url on subnav link
 * Call this function in $(document).ready
 */
function add_active_class_to_subnav() {
    //first check if subnav exists on page
    if ($('.pattern-group-subnav').length > 0) {
        //get current page url
        const current_url_pathname = window.location.pathname;
        let current_url = current_url_pathname.split('/').filter(Boolean).pop(); //last segment of current url only
        if (!current_url.endsWith('/')) {
            //making sure current_url ends with a /
            current_url = current_url + '/';
        }

        //loop through all li tags inside subnav to see if a url matches the current url
        $('.pattern-group-subnav .subnav-ul')
            .children()
            .each(function () {
                //find the the a tag inside this li and then get href
                let this_href = $(this).find('a').attr('href');
                let this_li_url = this_href.split('/').filter(Boolean).pop(); //last segment of href url only

                //Checks for if the a tag url ends with a / or not. Adds it if it does not.
                //The result is that from a user perspective within the CMS, it does not matter if the user adds the / to the url, this code will consider it the same.
                if (!this_li_url.endsWith('/')) {
                    this_li_url = this_li_url + '/';
                }

                //check if they match, if so add the active class
                if (current_url === this_li_url) {
                    $(this).addClass('active');
                    $(this).find('a').focus();
                }
            });
    }
}

/**
 * Fixes Owl Carousel ARIA roles for accessibility compliance.
 *
 * - Replaces role="presentation" on nav buttons with role="button".
 * - Adds aria-label attributes to Previous/Next buttons.
 * - Marks the carousel stage as a live region so screen readers
 *   announce slide changes.
 * - Sets aria-hidden on inactive slides and removes it from the active slide.
 * - Adds role="group" and aria-roledescription="slide" to each slide item.
 */
function pacecore_fix_owl_aria() {
    // Fix nav button roles and labels.
    $('.owl-prev').attr('role', 'button').attr('aria-label', 'Previous slide');
    $('.owl-next').attr('role', 'button').attr('aria-label', 'Next slide');

    // Mark disabled nav buttons with aria-disabled.
    $('.owl-prev.disabled, .owl-next.disabled').attr('aria-disabled', 'true');
    $('.owl-prev:not(.disabled), .owl-next:not(.disabled)').attr('aria-disabled', 'false');

    // Add live region to the carousel stage so slide changes are announced.
    $('.owl-stage').attr('aria-live', 'polite');

    // Mark each slide item with proper roles.
    $('.owl-item').each(function (index) {
        const $item = $(this);
        $item.attr('role', 'group');
        $item.attr('aria-roledescription', 'slide');
        $item.attr('aria-label', 'Slide ' + (index + 1));

        if ($item.hasClass('active')) {
            $item.removeAttr('aria-hidden');
        } else {
            $item.attr('aria-hidden', 'true');
        }
    });

    // Add the carousel role to the main container.
    $('.owl-carousel').attr('role', 'region').attr('aria-roledescription', 'carousel');
}

/**
 * Checks paragraph heights against preceding h3 headings and wraps them if shorter.
 *
 * Detects paragraphs that follow h3 elements within .columns-image-stats-stack-inner
 * and wraps the h3 and paragraph in a div with class 'heading-paragraph-wrapper' if the
 * paragraph height is less than the h3 height. This prevents the h3 from floating when
 * the paragraph is too short.
 */
function pacecore_check_paragraph_heights() {
    $('.columns-image-stats-stack-inner .wp-block-heading').each(function () {
        const $heading = $(this);
        const headingHeight = $heading.outerHeight();

        // Check if heading is already wrapped
        const $wrapper = $heading.parent('.heading-paragraph-wrapper');
        let $paragraph;

        if ($wrapper.length) {
            // Heading is wrapped, get paragraph from wrapper
            $paragraph = $wrapper.find('p').first();
        } else {
            // Heading is not wrapped, get next paragraph
            $paragraph = $heading.nextAll('p').first();
        }

        if ($paragraph.length) {
            // Get paragraph height without the bottom margin that increases visual size
            const $paragraphStyle = window.getComputedStyle($paragraph[0]);
            const paragraphMarginBottom = parseFloat($paragraphStyle.marginBottom);
            const paragraphHeight = $paragraph.outerHeight() - paragraphMarginBottom;

            if (paragraphHeight < headingHeight) {
                // Wrap if not already wrapped
                if (!$wrapper.length) {
                    $heading.add($paragraph).wrapAll('<div class="heading-paragraph-wrapper"></div>');
                }
            } else {
                // Unwrap if wrapped
                if ($wrapper.length) {
                    $wrapper.contents().unwrap();
                }
            }
        }
    });
}

/**
 * Sets the padding-top of each .columns-image-stats-stack-inner element to
 * match the outer height of the closest preceding h3 (.wp-block-heading)
 * within the parent .columns-image-stats-stack container.
 *
 * This ensures the inner box leaves enough room for the absolutely-positioned
 * heading that overlaps its top edge, regardless of the heading's rendered
 * height (which can vary with font size, line wrapping, etc.).
 */
function pacecore_set_stack_inner_padding() {
    $('.columns-image-stats-stack-inner').each(function () {
        const $inner = $(this);
        const $heading = $inner.prevAll('.wp-block-heading').first();

        if ($heading.length) {
            const headingHeight = $heading.outerHeight(true);
            $inner.css('padding-top', headingHeight + 'px');
        }
    });
}

//Close open Map SVG popup when clicking the page
$(document).on('mouseup touchend', function (e) {
    const mapSVGContainer = $('.mapsvg-details-container');

    // if the target of the click isn't the container nor a descendant of the container
    if (!mapSVGContainer.is(e.target) && mapSVGContainer.has(e.target).length === 0) {
        mapSVGContainer.empty();
    }
});

// Logic for scrolling to in-page links (links with #) in subnavs
// this hijacks WP smooth scrolling so maybe be a bit jerky
$(document).on('click', '.pattern-group-subnav a', function (e) {
    const clickedSubNav = $(this);
    const scrollTarget = clickedSubNav.attr('href');
    const headerNavHeight = $('.header-nav').outerHeight();
    const subNavHeight = $('.pattern-group-subnav').outerHeight();
    const scrollOffset = parseInt(headerNavHeight) + parseInt(subNavHeight);

    if (scrollTarget.startsWith('#')) {
        e.preventDefault();
        $(clickedSubNav).parent().siblings().not(clickedSubNav).removeClass('active');
        $(clickedSubNav).parent().addClass('active');
        $('html, body')
            .stop()
            .animate(
                {
                    scrollTop: $(scrollTarget).offset().top - scrollOffset,
                },
                10
            );
    }
});
